import { VersionedServiceConfig } from '../../types';
import {
  blueberrySizeBucketLabelsByVersion,
  SizeBucketLabelMap,
} from './blueberrySizeBucketLabelsDeprecated';

type blueberryFeatureFlag =
  | 'includeFlowers'
  | 'hasFlowerStages'
  | 'hasSizeBuckets';

type blueberryFeatureConfig = {
  [key in blueberryFeatureFlag]: boolean;
};

/**
 * Blueberry Service Config
 * @property {boolean} includeFlowers - true if any flower classes are present
 * @property {boolean} hasFLowerStages - true if classes for flower stages are present
 * @property {boolean} hasSizeBuckets - true if blueberry sizing is supported
 * @property {sizeBucketLabelMap | null} sizeBucketLabels - a label mapping for the
 * size buckets, if sizing is supported
 */
export interface blueberryConfig extends blueberryFeatureConfig {
  sizeBucketLabels: SizeBucketLabelMap | null;
}

const makeBlueberryConfig = ({
  includeFlowers = false,
  hasFlowerStages = false,
  hasSizeBuckets = false,
  sizeBucketLabels = null as SizeBucketLabelMap | null,
}): blueberryConfig => ({
  includeFlowers: includeFlowers,
  hasFlowerStages: hasFlowerStages,
  hasSizeBuckets: hasSizeBuckets,
  sizeBucketLabels: sizeBucketLabels,
});

/**
 * Blueberry Service config items by version range
 */
export const blueberryFeatureConfig: VersionedServiceConfig<blueberryConfig> = {
  '1-5': makeBlueberryConfig({}),
  '6': makeBlueberryConfig({ includeFlowers: true }),
  '6fit': makeBlueberryConfig({ includeFlowers: true }),
  '7-11': makeBlueberryConfig({
    includeFlowers: true,
    hasFlowerStages: true,
  }),
  '12-15': makeBlueberryConfig({
    // UPDATED: Split v12+ into v12-15
    includeFlowers: true,
    hasFlowerStages: true,
    hasSizeBuckets: true,
    sizeBucketLabels: blueberrySizeBucketLabelsByVersion['12-15'],
  }),
  '16-': makeBlueberryConfig({
    // NEW: v16+ with extended buckets
    includeFlowers: true,
    hasFlowerStages: true,
    hasSizeBuckets: true,
    sizeBucketLabels: blueberrySizeBucketLabelsByVersion['16-'],
  }),
};
